import { useEffect, useState } from "react";
import "./Reports.scss";
import ReportGroup from "./ReportsGroup";
import Button from "../../Components/Button/Button";
import { NumberFormatter, replaceUnderscore } from "../../../CommonFunction/common";
import { useRecoilState, useRecoilValue } from "recoil";
import { toggleExpandAllState } from "../../Components/HeaderDiv/HeaderDivComponents/IconsDiv/iconsAtomStates";
// // The top-level component that receives the entire dataset and iterates over it to render each top-level group using `ReportGroup`.

// // Iterates over the `data` prop, rendering a `ReportGroup` for each element. It's designed to handle potentially multiple top-level groups, each containing their accounts and sub-groups.

const ReportsMenu = ({ data, type, Profit }) => {
  const [isOpenExpand, setIsOpenExpand] = useRecoilState(toggleExpandAllState);
  useEffect(() => {
    setIsOpenExpand(false)
  }, [])


  return (
    <div className="menu">
      {/* <Button action={toggleAll} name="toggle-button">
        {isAllExpanded ? "Unstretch" : "Stretch"}
      </Button> */}
      {(type === "Expenses" || type == "Credit") && Profit && Object.values(Profit) && Object.values(Profit)[0] ? (
        <li className="menu-group-title ProfitLoss">
          <span>{replaceUnderscore(Object.keys(Profit)[0])}</span>
          <span>{Object.values(Profit)}</span>
        </li>
      ) : (
        ""
      )}
      {data?.map((group, index) => (
        <ReportGroup key={index} group={group} isAllExpanded={isOpenExpand} type={type} />
      ))}
      {type !== "Expenses" && type !== "Credit" && Profit && Object.values(Profit) && Object.values(Profit)[0] ? (
        <li className="menu-group-title ProfitLoss">
          <span>{replaceUnderscore(Object.keys(Profit)[0])}</span>
          <span>{Object.values(Profit)}</span>
        </li>
      ) : (
        ""
      )}
    </div>
  );
};

export default ReportsMenu;
